
import React from "react";
import { Breadcrumb, Button, Checkbox, Col, Input, InputNumber, Row, Select, Spin, Typography, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";

class CalculadoraList extends React.Component {

    state = {
        _navigate: false,
        calc: false,
        _loading: true,
        _map: false,
        _map_data: [],
        _params: window.location.href.split('/'),
        table_filter: { INSTITUTION_ID: '*', COURSE_ID: '*', CLASS_ID: '*' },
        INSTITUTION_ID: [],
        COURSE_ID: [],
        CLASS_ID: [],
        QTY_GRADUATE: 0,
        QTY_GUESS: 0,
        QTY_TOTAL: 0,
        TOTAL: 0,
        PARCELAS: 1,
        ITEMS: [],
        load: true
    }

    back = this.props.url;

    componentDidMount = () => {
        titleWeb('Calculadora')
        this.onFilters()
        this.onLoad()
    }

    onFilters = async() => {
        this.setState({load: true})
        await POST_API('/institution/search.php', { token: getToken(), filter: JSON.stringify(this.state.table_filter) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({INSTITUTION_ID: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
        await POST_API('/course/search.php', { token: getToken(), filter: JSON.stringify(this.state.table_filter) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({COURSE_ID: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
        await POST_API('/class/search.php', { token: getToken(), filter: JSON.stringify(this.state.table_filter) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({CLASS_ID: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
        this.setState({load: false})
    }

    onLoad = () => {
        POST_API('/budget_item/search.php', { token: getToken(), type: 'list' }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({ ITEMS: res.data })
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onCheck = (bool, item, index) => {

        this.setState({calc: true})
        var list = this.state.ITEMS;
        list[index]['boolean'] = bool;
        this.setState({ITEMS: list})

        setTimeout(() => {
            this.onCalc()
        }, 500);

    }

    onCalc = () => {

        var list = this.state.ITEMS;
        var total = 0;

        list.map((v, i) => {

            if (v.boolean) {

                if (v.TYPE === 'CF') {
                    total += Number(v.PRICE)
                }
                if (v.TYPE === 'CVP') {
                    total += Number(v.PRICE)*this.state.QTY_TOTAL
                }
                if (v.TYPE === 'CVF') {
                    total += Number(v.PRICE)*this.state.QTY_GRADUATE
                }
                if (v.TYPE === 'CVPP') {
                    total += Number(v.PRICE)*(Math.ceil(this.state.QTY_TOTAL/v.PROPORTION))
                }
                
            }

        })

        this.setState({ TOTAL: (total/this.state.QTY_GRADUATE) / this.state.PARCELAS, calc: false })

    }

    onClear = () => {

        this.setState({
            table_filter: { INSTITUTION_ID: '*', COURSE_ID: '*', CLASS_ID: '*' },
            QTY_GRADUATE: 0,
            QTY_GUESS: 0,
            QTY_TOTAL: 0,
            TOTAL: 0,
            PARCELAS: 1,
            ITEMS: [],
        })
        this.onLoad()

    }
    
    render = () => {

        const routes = this.props.bread
        
        if (this.state._navigate) {
            return (<Navigate to={'/'} />)
        }

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={this.props.ret}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} style={{marginBottom: 10}} align={'bottom'}>
                        <Col xs={24} md={12}>
                            <Typography className="label_filter">Instituição</Typography>
                            <Select loading={this.state.load} placeholder="Selecione..." style={{width: '100%'}} value={this.state.table_filter.INSTITUTION_ID} onChange={(v) => {this.setState({table_filter: { ...this.state.table_filter, INSTITUTION_ID: v }}); setTimeout(() => {this.onFilters()}, 500);}}>
                                <Select.Option value={'*'}>Selecione...</Select.Option>
                                { this.state.INSTITUTION_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                            </Select>
                        </Col>
                        <Col xs={24} md={6}>
                            <Typography className="label_filter">Curso</Typography>
                            <Select loading={this.state.load} placeholder="Selecione..." style={{width: '100%'}} value={this.state.table_filter.COURSE_ID} onChange={(v) => {this.setState({table_filter: { ...this.state.table_filter, COURSE_ID: v }}); setTimeout(() => {this.onFilters()}, 500); }}>
                                <Select.Option value={'*'}>Selecione...</Select.Option>
                                { this.state.COURSE_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                            </Select>
                        </Col>
                        <Col xs={24} md={6}>
                            <Typography className="label_filter">Classe</Typography>
                            <Select loading={this.state.load} placeholder="Selecione..." style={{width: '100%'}} value={this.state.table_filter.CLASS_ID} onChange={(v) => this.setState({table_filter: { ...this.state.table_filter, CLASS_ID: v }})}>
                                <Select.Option value={'*'}>Selecione...</Select.Option>
                                { this.state.CLASS_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.SEMESTER}/{v.YEAR}</Select.Option> ) }
                            </Select>
                        </Col>
                    </Row>
                    <Row className="table__row_table" gutter={[8,8]} style={{marginBottom: 10}} align={'bottom'}>
                        <Col xs={24} md={8}>
                            <Typography className="label_filter">Quantidade Formando</Typography>
                            <InputNumber style={{width: '100%'}} value={this.state.QTY_GRADUATE} onChange={(v) => {this.setState({QTY_GRADUATE: v, QTY_TOTAL: v*this.state.QTY_GUESS }); setTimeout(() => this.onCalc(), 500);}} />
                        </Col>
                        <Col xs={24} md={8}>
                            <Typography className="label_filter">Quantidade Convidado por Formando</Typography>
                            <InputNumber style={{width: '100%'}} value={this.state.QTY_GUESS} onChange={(v) => {this.setState({QTY_GUESS: v, QTY_TOTAL: v*this.state.QTY_GRADUATE }); setTimeout(() => this.onCalc(), 500);}} />
                        </Col>
                        <Col xs={24} md={8}>
                            <Typography className="label_filter">Quantidade Total Pessoas</Typography>
                            <InputNumber style={{width: '100%'}} value={this.state.QTY_TOTAL} readOnly />
                        </Col>
                    </Row>
                    <Row className="table__row_table" gutter={[8,8]} style={{marginBottom: 10}} align={'bottom'}>
                        { this.state.ITEMS.map((v, i) => (
                            <Col span={24} key={i}>
                                <Checkbox onChange={(b) => this.onCheck(b.target.checked, v, i)}>{v.NAME}</Checkbox>
                            </Col>
                        )) }
                    </Row>
                    <Row className="table__row_table" gutter={[8,8]} style={{marginBottom: 10}} align={'bottom'}>
                        <Col xs={12} md={6}>
                            <Typography className="label_filter">Quantidade Parcelas</Typography>
                            <InputNumber style={{width: '100%'}} min={1} value={this.state.PARCELAS} onChange={(v) => {this.setState({PARCELAS: v }); setTimeout(() =>  this.onCalc(), 500);}} />
                        </Col>
                        <Col xs={12} md={6}>
                            <Typography className="label_filter">Total</Typography>
                            <InputNumber prefix={this.state.calc ? <Spin size="small" /> : 'R$'} style={{width: '100%'}} value={this.state.TOTAL} readOnly />
                        </Col>
                        <Col xs={24} md={12}>
                            <Button loading={this.state.load || this.state.calc}  type="primary" shape="round" style={{float: 'right', marginLeft: 10}}>Salvar</Button>
                            <Button loading={this.state.load || this.state.calc} onClick={() => this.onClear()} type="default" shape="round" style={{float: 'right'}}>Limpar</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )

    }

}

export default CalculadoraList;